module.exports = __webpack_public_path__ + "img/img2.8805c453.png";